export const USER_NAME = "userName";
export const PASSWORD = "password";
export const TOKEN = "token";
export const REFRESH_TOKEN = "refreshToken";
export const GROUP = "GROUP";
export const DEVICES = "Devices";
